export default __webpack_public_path__ + "static/awards-mb-arg-f2a339398b87c77d6bef4754ebe44a7d.png";